// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"180":"f41bf520","313":"b92d3464"}[chunkId] + ".chunk.css";
};